import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'
import { jwtTokenHandler } from './jwtTokenHandler'

// Swagger: https://housekeeper-web-dev.kingnetsmart.com.tw/swagger/index.html#/
const instance = axios.create({
  baseURL: `${process.env.VUE_APP_HOUSEKEEPER_WEB_URL}/api/v1/Alarm`
})
instance.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
// 佩穎之後似乎也會寫成共用函式
const genAlertIfNotExist = (msg, finallyCallback) => {
  // eslint-disable-next-line eqeqeq
  if (document.getElementsByClassName('v-modal').length == 0) {
    Vue.prototype
      .$alert(msg, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).finally(() => {
        finallyCallback()
      })
  }
}
// 401 重新登入
const alertUnauthorized = () => {
  genAlertIfNotExist('登入過期或驗證失敗，請重新登入', () => {
    router.push({ name: 'LoginMain' })
  })
}
// 403 沒有啟用此服務
const alertForbidden = (service = '告警管理') => {
  genAlertIfNotExist(`未啟用${service}服務`, () => {
    Vue.prototype.$toMainPage()
  })
}
// 403 非最高管理者
const alertNotHighestAdmin = () => {
  genAlertIfNotExist('您並非最高權限管理者，無法進行此操作')
}
// 404 有可能為伺服器重新部署中、 409 為資料寫入衝突，應過一陣子就可以了
const alertTryAgainLater = (errorMessage = '請稍後再試') => {
  Vue.prototype.$message.error(errorMessage)
}
// 500
const alertServerError = (errorMessage = '伺服器發生錯誤') => {
  Vue.prototype.$message.error(errorMessage)
}
// 先照舊，之後再整合多個 Alert 的 Issue
instance.interceptors.request.use(
  async (config) => {
    const newConfig = { ...config }
    if (Vue.prototype.$getCookie('comLoginToken')) {
      await jwtTokenHandler() // 確保 JWT Token 有效
      const xCorrelationId = Vue.prototype.$getGuid()
      newConfig.headers = {
        authorization: Vue.prototype.$getCookie('JwtToken'),
        'x-requestid': Vue.prototype.$getGuid(),
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      newConfig.metadata = { startTime: new Date() }
      return newConfig
    } else {
      alertUnauthorized()
    }
  },
  (err) => {
    return Promise.reject(err)
  }
)
// 先照舊，之後再整合多個 Alert 的 Issue
instance.interceptors.response.use(
  res => {
    const newRes = { ...res }
    newRes.config.metadata.endTime = new Date()
    newRes.duration =
      newRes.config.metadata.endTime - newRes.config.metadata.startTime
    return newRes
  },
  err => {
    const newErr = { ...err }
    newErr.config.metadata.endTime = new Date()
    newErr.duration =
      newErr.config.metadata.endTime - newErr.config.metadata.startTime
    if (newErr && newErr.response && newErr.response.status) {
      const { status } = newErr.response
      switch (status) {
        case 401:
          alertUnauthorized()
          break
        case 403:
          if (newErr.response.config.url.includes('SwitchNotification')) {
            alertNotHighestAdmin()
          } else {
            alertForbidden()
          }
          break
        case 404:
        case 409:
          alertTryAgainLater()
          break
        case 500:
          alertServerError()
          break
        default:
          alertTryAgainLater()
          break
      }
    }
    return Promise.reject(newErr)
  }
)
export const apiBaAlert = {
  getAssetCategory: (params) => instance.get('/category', { params, baseURL: `${process.env.VUE_APP_HOUSEKEEPER_WEB_URL}/api/v1/asset` }),
  getEvent: (params) => instance.get('/event', { params }),
  getEventById: (id) => instance.get(`/event/${id}`),
  getLogFileById: (id) => instance.post(`/Log/${id}/LogFile`),
  reportEvent: (eventId, data, config) => instance.post(`/event/${eventId}/report`, data, config),
  getTag: (params) => instance.get('/tag', { params }),
  switchNotification: (tagId, data, config) => instance.patch(`/tag/${tagId}/SwitchNotification`, data, config),
  getLog: (params) => instance.get('/log', { params }),
  getLogExport: (params) => instance.get('/log/export', {
    responseType: 'blob',
    params
  }),
  getTagListFromBaDevice: (baDeviceId) => instance.get(`/Tag/FromBaDevice/${baDeviceId}/`),
  getAnalysis: (params) => instance.get('/event/Analysis', { params }),
  getUnfinishedEvent: (params, config) => instance.get('/Event/Unfinished', config), // 取得未結案告警事件列表
  getPrivateEventById: (id) => instance.get(`/PrivateEvent/${id}`),
  getPrivateUnfinishedEvent: (params, config) => instance.get('/PrivateEvent/Unfinished', config), // 取得私區未結案告警事件列表
  reportPrivateEvent: (eventId, data, config) => instance.post(`/PrivateEvent/${eventId}/report`, data, config)
}
